export default __webpack_public_path__ + "static/media/videoY.291a68c0.mp4";